
import React, { useRef, useState } from "react";
import { Button, Icon, Input, InputProps, Ref, SemanticICONS } from "semantic-ui-react";
import { SemanticCOLORS } from "semantic-ui-react/dist/commonjs/generic";
import "./_EvaluationCounter.less"

export interface EvaluationCounterProps {
    label?: string
    color: SemanticCOLORS;
    icon?: SemanticICONS;
    value?: number;
    onChange: (value?: number) => void;
    allowNegative?: boolean;
};

export const EvaluationCounter: React.FC<EvaluationCounterProps> = ({
    label,
    icon,
    color,
    value,
    allowNegative = false,
    onChange
}) => {


    const count = typeof value === "number" ? value : 0;

    const updateValue = (value?: number) => {
        let newCount = ["number", "undefined"].includes(typeof value) ? value : count;
        if (newCount && newCount < 0) {
            newCount = 0
        };
        onChange(newCount)
    };

    const increase = () => updateValue(count + 1);
    const decrease = () => updateValue(count - 1);


    const [_1, setFocusCount] = useState(0);  // eslint-disable-line
    const focusReRender = () => setFocusCount((prev) => prev + 1);

    const inputWrapper = useRef<HTMLDivElement>();
    const inputElement = inputWrapper.current?.getElementsByTagName("input")[0];
    const inputActive = inputElement === document.activeElement;

    const [inputValue, setInputValue] = useState("");

    const handleInputFocus = () => {
        setInputValue("");
        focusReRender();
    };

    const handleInputBlur = () => {
        updateValue(inputElement?.value?.length ? Number(inputElement.value) : value);
        focusReRender();
    }

    const hanldeInputChange: InputProps["onChange"] = (_1, { value }) => {
        setInputValue(value);
    };

    const handleInputKeyDown = (event: KeyboardEvent) => {
        if (event.key == "Enter") {
            event.preventDefault();
        };
    };


    return (
        <div className="EvaluationCounter-container">
            {label && (
                <div className="EvaluationCounter-label">
                    {icon && <Icon name={icon} color={color} />}
                    {label}
                </div>
            )}

            <div className="EvaluationCounter-row">
                <div className="EvaluationCounter-column">
                    <Button
                        type="button"
                        className="EvaluationCounter-button"
                        onClick={decrease}
                        icon="minus"
                    />
                </div>

                <div className="EvaluationCounter-column">
                    <Ref innerRef={inputWrapper as any}>
                        <Input
                            type="number"
                            onFocus={handleInputFocus}
                            onBlur={handleInputBlur}
                            onKeyDown={handleInputKeyDown}
                            className="EvaluationCounter-input"
                            value={inputActive ? inputValue : value}
                            onChange={hanldeInputChange}
                        />
                    </Ref>
                </div>

                <div className="EvaluationCounter-column">
                    <Button
                        type="button"
                        className="EvaluationCounter-button"
                        onClick={increase}
                        icon={<Icon name="plus" color={color} />}
                    />
                </div>
            </div>
        </div>
    );
};
